import type { ReactNode } from 'react';

export const symbol_nat: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M156-360q-48 0-82-34t-34-82q0-48 34-82t82-34q40 0 72 20t43 62h177q13 0 21.5 8.5T478-480q0 13-8.5 21.5T448-450H271q-11 42-43 66t-72 24Zm40-76q16-16 16-40t-16-40q-16-16-40-16t-40 16q-16 16-16 40t16 40q16 16 40 16t40-16Zm344-44q0-137-89.5-232.5T228-819q-12-1-20-10t-8-21q0-13 9-21.5t21-7.5q144 11 251.5 114T600-510h206l-57-57q-9-9-9-21.5t9-21.5q9-9 21.5-9t21.5 9l109 109q5 5 7 10t2 11q0 6-2 11t-7 10L792-350q-9 9-21 8.5t-21-9.5q-9-9-9-21.5t9-21.5l56-56H600q-11 152-118.5 255T230-81q-12 1-21-7.5t-9-21.5q0-12 8-21t20-10q133-11 222.5-107T540-480Z"
		/>
	</svg>
);
